import { useCallback } from "react";
import { useNavigate } from "@/hooks/useDeskNavigate";

/**
 * iter381 pt 11 — flèche « ← » = page précédente exacte dans Le Desk (état conservé par les pages : onglet, filtres, groupes, défilement via ScrollMemory).
 * Sans page précédente dans Le Desk (lien direct, notification) → page parente logique `fallback`.
 */
export const hasDeskHistory = () => typeof window !== "undefined" && Number(window.history.state?.idx || 0) > 0;

export default function useGoBack(fallback) {
  const navigate = useNavigate();
  return useCallback(() => { if (hasDeskHistory()) navigate(-1); else navigate(fallback); }, [navigate, fallback]);
}
